import { PRACTICES } from "@/data/practices";

const hasBorough = (borough: string | null | undefined): borough is string =>
  typeof borough === "string" && borough.trim().length > 0;

export const toBoroughSlug = (borough?: string | null): string =>
  hasBorough(borough)
    ? borough.toLowerCase().replace(/\s+/g, "-").replace(/[^a-z0-9-]/g, "")
    : "";

export const getUniqueBoroughs = (): string[] => {
  const boroughs = new Set(PRACTICES.map((p) => p.borough).filter(hasBorough));
  return [...boroughs].sort((a, b) => a.localeCompare(b));
};

export const getBoroughFromSlug = (slug: string): string | undefined => {
  if (!slug?.trim()) return undefined;
  const boroughs = getUniqueBoroughs();
  return boroughs.find((b) => toBoroughSlug(b) === slug);
};

export const getPracticesByBorough = (borough: string) =>
  hasBorough(borough) ? PRACTICES.filter((p) => p.borough === borough) : [];
